import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	groupIcon: {
		id: 'jql-builder-basic-picker.format-option-label.avatar-option-label.group-icon',
		defaultMessage: 'Group Icon',
		description: 'The text used on the group icon label',
	},
});
